// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageMoveAnkerFunc() {
  const specOffset = {
    pcLarge: 350,
    pc: 350,
    sp: 340,
  };

  const getSpecOffset = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth >= 1551) {
      return specOffset.pcLarge;
    }

    if (windowWidth >= 769) {
      return specOffset.pc / 1550 * windowWidth;
    }

    return specOffset.sp / 768 * windowWidth;
  };

  var headerHeight, position;
  $('a[href^="#"]:not(.notScroll)').each(function () {
    var pageUrl = location.href.split('#')[0];
    if (this.href.indexOf(pageUrl + '#') === 0) {
      var id = this.href.split('#')[1];
      $(this).on('click', function () {
        
        var isSP = window.innerWidth < 768;
        var isCharacterLink = ['rudeus', 'sylphiette', 'roxy', 'eris'].indexOf(id) !== -1;

        // SP（767px以下）のときは「.drawerScroll」を動かす
        // PC（768px以上）のときは「body,html」を動かす
        var $scrollTarget = isSP ? $('.drawerScroll') : $('body,html');

        if (isSP) {
          headerHeight = 10;
        } else {
          headerHeight = 20;
        }

        // キャラクターへのリンクは、通常より少し上の位置から表示する
        if (isCharacterLink) {
          headerHeight += 180;
        }

        // スペックセクションは、画面内で少し下の位置に表示する
        if (id === 'spec') {
          headerHeight -= getSpecOffset();
        }

        // ターゲット要素（スクロール先）が存在するかチェック
        var $target = $('#' + id);
        if ($target.length) {
          
          if (isSP) {
            position = $scrollTarget.scrollTop() + ($target.offset().top - $scrollTarget.offset().top) - headerHeight;
          } else {
            position = $target.offset().top - headerHeight;
          }

          $scrollTarget.stop().animate({
            scrollTop: position
          }, 1000, 'easeInOutQuart');
        }

        return false;
      });
    }
  });
}
